import { render, staticRenderFns } from "./EditorListModal.vue?vue&type=template&id=70dda2b7&scoped=true&"
import script from "./EditorListModal.vue?vue&type=script&lang=js&"
export * from "./EditorListModal.vue?vue&type=script&lang=js&"
import style0 from "./EditorListModal.vue?vue&type=style&index=0&id=70dda2b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dda2b7",
  null
  
)

export default component.exports